<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="12">
            <left-emp-menu></left-emp-menu>
          </v-col>
          <v-col>
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-list three-line subheader>
                    <v-card-title class="lighten-5">
                       แนบไฟล์ประวัติส่วนตัว (Resume)
                      <v-icon color="#871B12"
                        >mdi-account-circle-outline
                      </v-icon>
                    </v-card-title>
                    <v-divider color="#871B12"></v-divider>
                    <v-col cols="12" class="text-center">
                      <v-container grid-list-xl>
                        <v-row>
                          <v-col cols="12">
                            <v-file-input
                            v-model="files"
                            color="deep-purple accent-4"
                            counter
                            accept=".pdf"
                            label="เลือกไฟล์ (ไม่เกิน 2 MB) "
                            show-size
                            prepend-icon="mdi-paperclip"
                            :rules="imageRules"
                            @change="pdfupload"
                          ></v-file-input>
                             <v-btn small
                                  dark
                                  color="purple"
                                  :disabled="!valid_add"
                                  @click="editData('edit')"
                                >
                                  <v-icon left>mdi-cloud-upload</v-icon>
                                  อัพโหลด
                                </v-btn>
                          </v-col>
                        </v-row>
                        <br>
                        <div>
                          <pdf :src="formUpdate.empFileUpload"></pdf>
                        </div>
                      </v-container>
                    </v-col>
                  </v-list>
                  <v-col cols="12" class="text-right">
                  <v-btn small
                  dark
                  color="red"
                  :disabled="!valid_add"
                  @click="editData('delete')"
                >
                  <v-icon left>mdi-delete</v-icon>
                  ลบ
                </v-btn>

                  </v-col>
                </v-card>
                <br>
                <br>
                <br>
                <v-row no-gutters>
              <v-footer fixed height="60px" color="#262A34">
                <v-col class='text-right'>
                <v-btn small
                  color="#E0E0E0"
                  @click="pushBack"
                >
                <v-icon left> mdi-arrow-left-circle-outline</v-icon>
                  ย้อนกลับ
                </v-btn>
                <v-btn small
                  color="#E0E0E0"
                  @click="pushNext"
                >
                  หน้าถัดไป
                  <v-icon right> mdi-arrow-right-circle-outline</v-icon>
                </v-btn>
              </v-col>
              </v-footer>
            </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import EmpMenu from './EmployeeMenu.vue'
// import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date
import pdf from 'vue-pdf'

export default {
  components: {
    'left-emp-menu': EmpMenu,
    // 'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    moment,
    readXlsxFile,
    pdf
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      value: 1,
      PK: '',
      path: '/employee/', // Path Model
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu5: false,
      menu4: false,
      menu3: false,
      valid_add: true,
      dialogAdd: false,
      session: this.$session.getAll(),

      formUpdate: {
        empCode: '',
        empId: '',
        empImageUrl: '',
        empFileUpload: ''
      },
      formUpdateItem: {
        empCode: '',
        empId: '',
        empImageUrl: '',
        empFileUpload: ''
      },
      imageRules: [
        (value) =>
          !value ||
          value.size < 5000000 ||
          'Avatar size should be less than 5 MB!'
      ],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      empId: '',
      files: null,
      can: null,
      checkHide: false
    }
  },
  async mounted () {
    this.dataReady = false
    await this.getGetTokenForEmployee()
    await this.checkEmpData()
  },
  methods: {
    async checkEmpData () {
      this.can = localStorage.getItem('CanEdit')
      this.can = (this.can === 'true')
      if (localStorage.getItem('roll') === 'Employee') {
        this.dataEmp = JSON.parse(localStorage.getItem('data'))
      } else if (localStorage.getItem('roll') === 'HR') {
        this.rollHR = true
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      } else {
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      }
      if (localStorage.getItem('roll')) {
        await this.SubmitDataById()
      }
    },
    async SubmitDataById () {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "getID?empId=" + this.dataEmp.empId,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            console.log(response.data)
            Object.assign(this.formUpdate, response.data)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async editData (status) {
      let dt = this.formUpdate
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let id = dt.empId
          let databylogin = localStorage.getItem('data')
          dt.LAST_USER = databylogin.userName
          if (status === 'delete') {
            dt.empFileUpload = '/'
          }
          let ds = {
            empFileUpload: dt.empFileUpload,
            LAST_USER: databylogin.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + id,
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              // Debug response
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              await this.SubmitDataById()
              this.dataReady = true
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    pushNext () {
      this.$router.push(
        '/HRM/Employee/EmployeePrivacy')
    },
    pushBack () {
      this.$router.push(
        '/HRM/Employee/EmployeeJobExperience')
    },
    async pdfupload () {
      const _this = this
      let params = new FormData()
      _this.data = JSON.parse(localStorage.getItem('data'))
      params.append('file', _this.files)
      await axios
        .post(_this.DNS_IP + '/employee/upload', params)
        .then(function (response) {
          _this.formUpdate.empFileUpload = _this.DNS_IP + '/' + response.data
        })
    }
  }
}
</script>
<style scope>
.scroll {
  overflow-y: scroll;
}
.lighten-5 {
  font-family: Kanit;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;

  color: #871b12;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeUploadFile.vue